module.exports = __webpack_public_path__ + "static/media/OTROS.a18fc373.png";